import { formatUnit } from '@dynatrace-sdk/units';

import type { ChartUnit } from '../types/chart-unit.js';
import { isUnit } from '../types/formatter.js';
import type { TimeseriesUnit } from '../types/timeseries.js';

export function getUnitAsString(unit: TimeseriesUnit | ChartUnit) {
  if (!unit) {
    return '';
  }

  if (isUnit(unit)) {
    return formatUnit(unit);
  }

  return unit.toString();
}
